"use client";

import { useState } from "react";

/**
 * Whether the nav's columns have moved yet, for SideNav's `data-nav-motion`
 * (app/globals.css). `columns` names what is open: the column beside the
 * rail ("search", "panel" or nothing) and Sabine's at the right edge.
 *
 * Undefined until it first changes, so nothing animates on page load; then
 * "resize", since opening and closing are the same motion played either
 * way. The value is worked out during the render that changes `columns`, so
 * it is on the frame in the same commit as the new widths, which is when
 * the browser picks the transition.
 */
export function useNavColumnMotion(columns) {
  const [last, setLast] = useState({ columns, motion: undefined });
  if (last.columns === columns) return last.motion;
  setLast({ columns, motion: "resize" });
  return "resize";
}
